<template>
  <div>
    <span
      v-for="(tag, i) in tags"
      :key="tag.id"
      :style="getTagStyle(tag)"
      class="inline-block lowercase mr-4"
    >
      {{ tag.text
      }}<span v-if="i !== tags.length - 1" class="font-blank">,</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'WorkTags',

  props: {
    tags: {
      default: () => [],
      type: Array
    }
  },

  methods: {
    getTagStyle(tag) {
      return {
        color: tag.textColor,
        backgroundColor: tag.bgColor
      }
    }
  }
}
</script>
